import createClient from 'openapi-fetch';
import type { paths } from '@/types/ai-api';
import { signinGuestUuid, signinWithZzimToken } from './actions';

const DEFAULT_AI_SERVER_BASE_URL = 'http://localhost:3002';

export async function getUserIdForAi(): Promise<string> {
  const signinResult = await signinWithZzimToken();
  const userId = signinResult?.user?.id;
  if (userId) return userId;

  const guestUuid = await signinGuestUuid();
  return guestUuid ?? 'anonymous';
}

export function createAiApi() {
  const baseUrl = process.env.NEXT_PUBLIC_PLANNER_AI_SERVER_URL ?? DEFAULT_AI_SERVER_BASE_URL;

  return createClient<paths>({
    baseUrl,
    credentials: 'include',
  });
}
